import axios from "axios";
import queryString from 'query-string';
import { useState, useEffect } from 'react';
import { API_URL } from '../../../constants';
import { useAuth } from '../../../provider';
import { useLocation } from "react-router-dom";
import OnboardingStep3 from "./Steps/OnboardingSteps3";
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import Grid from '@mui/material/Grid';
import PageProtectedNew from "../../../components/Page/PageProtectedNew";
import CartItemSub from "./StepExec/CartItemSub";
import ButtonForm from '../../../components/Button/ButtonForm';


export default function OnboardingSub() {
    
const checkoutUrl = `${API_URL}/api/stripe/create-checkout-subscription`
const customerprofileUrl = `${API_URL}/api/stripecustomer`

const { state } = useAuth();

    const [custprofile, setCustprofile] = useState(null);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState("");
    const [session_id, setSession_id] = useState();

    let location = useLocation();

    const retrieveCustomerId = () => {
      axios.get(customerprofileUrl)
        .then((res) => {
          let custid = res.data;
          setCustprofile(custid[0].stripe_customer_id)
  
        })
        .catch(function (error) {
          if (error.response) {
            // Request made and server responded
            setError(error.response.data);
          } else if (error.request) {
            // The request was made but no response was received
            setError("The request was made but no response was received.");
          } else {
            // Something happened in setting up the request that triggered an Error
            setError("Error: " + error.message);
          }
        });
    };
  

    useEffect(() => {

    retrieveCustomerId()
		// Check to see if this is a redirect back from Checkout
		// const query = new URLSearchParams(window.location.search);
		const parsed = queryString.parse(location.search);

		if (parsed.success) {
      setMessage(<p>Thank you for subscribing to plan FREE! A confirmation email was sent to you.<br /> Please proceed to the next step.</p>);
			setSession_id(parsed.session_id)
       
    };

		if (parsed.canceled) {
			setMessage(
        "Something went wrong -- please repeat subscribing for plan FREE"
      );
   //  console.log(parsed);
		}
	}, []);

  // console.log(custprofile)

return (
<>

<PageProtectedNew
    
    main = {<>

    <Grid container sx={{mb:4, mt: {xs: '1rem', sm: '1rem', xl: '8rem'}, ml: {xs: '1rem', sm: '2rem', xl: '12rem'}, mr: {xs: '1rem', sm: '2rem', },}}>
    
    <Grid item xs={12}>  <Typography variant='h4' sx={{ml: {xs: 0, sm: 8}, p:1, }}> 
        Please continue onboarding with step 3:</Typography> </Grid> 
     
        <Grid item xs={12} sm={5} sx={{mt: {xs: '1rem', lg: '0.5rem', xl: '4rem'}, mb: {xs: '4rem', lg: 1}, pl: {lg: '4rem', xl: '6rem'},  pr: {sm: '2rem', md: '0rem'} }}> 
          <OnboardingStep3 />     
        </Grid> 
     
        <Grid item xs={12} sm={6} sx={{mr: {xl:'0'}, pr: {lg: '8rem', xl: '0rem'}, }}> 
            <Grid item xs={12}>   <CartItemSub />  </Grid>  
            <Grid item xs={12} xl={10} sx={{mr: {xs:4, sm: 0, }, mt: {xs:2, }, mb: {xs:2, sm: 0 }, display: 'flex', justifyContent: 'flex-end', }}> 

            
            <form action={checkoutUrl} method='POST'>
                  <input type="hidden" name="email" value={state.user.email} />
                  <input type="hidden" name="userid" value={state.user.id} />
                  <input type="hidden" name="fname" value={state.user.first_name} />
                  <input type="hidden" name="lname" value={state.user.last_name} />
                  <input type="hidden" name="custid" value={custprofile} />
              		<ButtonForm name={ 'Order' } />
            </form>    

             </Grid>  

             <Grid item xs={12} xl={11} sx={{mr: {xs:4, sm: 0 }, mt: {xs:4, }, mb: {xs:2, sm: 0 }, display: 'flex', justifyContent: 'center',}}>  
                      {message && <Alert severity="info" variant="filled" sx={{borderRadius: '18px', p:2}}> 
                                      <Typography variant="h6" sx={{ fontFamily: 'Arial', fontWeight: 600}}>{message} </Typography> 
                                  </Alert> }
                    </Grid>  
          </Grid>  

    </Grid>

    </>}
/>
</>
)}